export function ClippingPathDivider() {
  return (
    <div className="w-full h-16 relative">
      <svg
        className="w-full h-full"
        viewBox="0 0 1440 54"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        preserveAspectRatio="none"
      >
        <path
          d="M1440.01 0.00109863L1439.99 54.0011H-0.00921631L1440.01 0.00109863Z"
          fill="var(--homepage-primary)"
        />
      </svg>
    </div>
  );
}
